import { useEffect, useState } from 'react';
import getColumnClass from '../../utils/getColumnClass';
import CardSkeleton from '../Common/CardSkeleton';
import GridControls from '../Common/GridControls';
import ProductCard from '../Shop/ProductCard';

function BagsForLadies({ ladiesBagProducts, isLoading, error }) {
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('BagsForLadiesGridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('BagsForLadiesGridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="container-fluid px-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-12 text-center">
          <div className="categories_title">
            <h2 className="fw-bold">Ladies Bags</h2>
            <hr className="featured_underline mb-3" />
          </div>
          <div className="ladies_product_text">
            <p>
              Style yourself with our beautiful handbags — from casual to
              classic, in colors and styles that match your personality.
            </p>
          </div>
        </div>
      </div>
      <GridControls
        gridSize={gridSize}
        setGridSize={setGridSize}
        windowWidth={windowWidth}
      />
      <div className="row">
        {error && <em className="form_error">{error}</em>}
        {isLoading && <CardSkeleton cards={8} />}
        {ladiesBagProducts?.slice(0, 8).map((product) => (
          <div
            key={product.product_id}
            className={` p-2 ${getColumnClass(gridSize, windowWidth)}`}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BagsForLadies;
